/**
 * Dynamic favicon badge — overlays a red counter pill on the existing site
 * favicon (found in `<link rel="icon">`) so the browser tab reflects unread
 * count in real time. No external libs. Draws once per count-change and
 * swaps the DOM icon href.
 */

let cachedBase = null;

async function loadBase() {
  if (cachedBase) return cachedBase;
  const link = document.querySelector('link[rel~="icon"]') || document.querySelector('link[rel="shortcut icon"]');
  const href = link?.href || `${window.location.origin}/favicon.ico`;
  try {
    const img = new Image();
    img.crossOrigin = "anonymous";
    await new Promise((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = reject;
      img.src = href;
    });
    cachedBase = img;
    return img;
  } catch (_e) {
    return null;
  }
}

let currentCount = -1;

export async function setFaviconBadge(count) {
  if (count === currentCount) return;
  currentCount = count;
  const size = 64;
  const canvas = document.createElement("canvas");
  canvas.width = size; canvas.height = size;
  const ctx = canvas.getContext("2d");
  const base = await loadBase();
  if (base) ctx.drawImage(base, 0, 0, size, size);

  if (count > 0) {
    // Solid red circle
    const r = 20;
    ctx.beginPath();
    ctx.arc(size - r, r, r, 0, Math.PI * 2);
    ctx.fillStyle = "#ef4444";
    ctx.fill();
    // Count text
    ctx.fillStyle = "#ffffff";
    ctx.font = "bold 26px system-ui, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const label = count > 9 ? "9+" : String(count);
    ctx.fillText(label, size - r, r + 1);
  }

  const dataUrl = canvas.toDataURL("image/png");
  let link = document.querySelector('link[rel~="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/png";
  link.href = dataUrl;
}
